export const LINE_BLUE = '#37C9E9';
export const LINE_PURPLE = '#764DCC';
export const LINE_GREEN = '#37E97E';
export const LINE_YELLOW = '#F2B133';

export const LINES: string[] = [LINE_BLUE, LINE_PURPLE, LINE_GREEN, LINE_YELLOW];
